import hiLocale from 'element-ui/lib/locale/lang/en'
import home from './hi/home'

const hi = {
    language: 'हिन्दी',
    message: {
        'home': {
            ...home,
            enterEmail: 'कृपया ईमेल दर्ज करें',
            save: 'सहेजें',
            saveSuccess: 'सफलतापूर्वक सहेजा गया',
            pointHistory: 'अंक इतिहास',
            type: 'प्रकार',
            remark: 'टिप्पणी',
            pendingComment: 'समीक्षा लंबित',
            commented: 'समीक्षा की गई',
            selectDate: 'तारीख चुनें',
            loginSuccess: 'लॉगिन सफल',
            loginFail: 'लॉगिन विफल',
            close: 'बंद करें',
            required: 'आवश्यक',
            nickname: 'उपनाम',
            enterNickname: 'कृपया उपनाम दर्ज करें',
            gender: 'लिंग',
            male: 'पुरुष',
            female: 'महिला',
            secret: 'गोपनीय',
            birthday: 'जन्मदिन',
            checkoutLoadFailed: 'भुगतान जानकारी लोड करने में विफल। कृपया बाद में पुनः प्रयास करें।',
            checkoutErrorTitle: 'सूचना',
            goAddAddress: 'डिलीवरी पता जोड़ें',
            shop_order_selectOrAddAddress: 'कृपया चेकआउट से पहले एक डिलीवरी पता जोड़ें और उसे डिफ़ॉल्ट के रूप में सेट करें।',
            shop_order_cartEmpty: 'कार्ट खाली है, चेकआउट नहीं किया जा सकता।',
            shop_order_cartHasNotActive: 'कुछ उत्पाद अप्रकाशित या अमान्य हैं, चेकआउट नहीं किया जा सकता।',
            shop_order_cartHasNotMarketable: 'कुछ उत्पाद हटा दिए गए हैं, चेकआउट नहीं किया जा सकता।',
            shop_order_cartHasLowStock: 'स्टॉक अपर्याप्त है, चेकआउट नहीं किया जा सकता।',
            shop_order_cartHasExpiredGoods: 'दुकान के कुछ उत्पाद समाप्त हो गए हैं, चेकआउट नहीं किया जा सकता।',
            shop_order_typeIsNull: 'ऑर्डर प्रकार की पहचान नहीं हो सकी, कृपया उत्पाद प्रकार जांचें।',
            shop_order_goodsNotFound: 'उत्पाद जानकारी मौजूद नहीं है या हटा दी गई है।',
            shop_order_giftNotForSale: 'उपहार उत्पाद सीधे नहीं खरीदे जा सकते।',
            common_message_badRequest: 'अमान्य अनुरोध, कृपया उत्पाद और पैरामीटर जांचें।',
        },
    },
    '手机号码最小长度为8位': 'मोबाइल फोन नंबर की न्यूनतम लंबाई 8 अंक है',
    '邮箱账号名称最小长度为6位': 'ईमेल खाते के नाम की न्यूनतम लंबाई 6 अक्षर है',
    '邮箱只能包含英文，数字等字符': 'ईमेल में केवल अंग्रेजी, संख्याएं और अन्य अक्षर हो सकते हैं',
    '请选择正确的收货地址': 'कृपया सही डिलीवरी पता चुनें',
    Dict_language_status_0: 'अक्षम',
    Dict_language_status_1: 'सक्षम',
    Dict_member_label_type_1: 'शर्त लेबल',
    Dict_member_label_type_2: 'मैनुअल लेबल',
    Dict_member_level_type_0: 'उपभोग स्तर (LV)',
    Dict_member_level_type_1: 'सशुल्क सदस्य (VIP)',
    Dict_member_growth_action_type_1: 'ऑर्डर करें',
    Dict_member_growth_action_type_2: 'दैनिक लॉगिन',
    Dict_member_growth_action_type_3: 'समीक्षा पोस्ट करें',
    Dict_member_growth_action_type_4: 'प्रोफ़ाइल पूर्ण करें',
    Dict_paid_member_payment_type_0: 'बैलेंस भुगतान',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'वैध',
    Dict_paid_member_record_status_1: 'समाप्त',
    Dict_paid_member_record_status_2: 'धनवापसी की गई',
    Dict_point_lottery_prize_type_0: 'अंक',
    Dict_point_lottery_prize_type_1: 'कूपन',
    Dict_point_lottery_prize_type_2: 'भौतिक पुरस्कार',
    Dict_point_lottery_prize_type_3: 'भाग लेने के लिए धन्यवाद',
    Dict_notification_channel_type_0: 'एसएमएस',
    Dict_notification_channel_type_1: 'ईमेल',
    Dict_notification_channel_type_2: 'साइट के भीतर संदेश',
    Dict_notification_channel_type_3: 'पुश सूचना',
    Dict_announcement_status_0: 'मसौदा',
    Dict_announcement_status_1: 'प्रकाशित',
    Dict_announcement_status_2: 'हटाया गया',
    Dict_live_permission_status_0: 'आवेदन नहीं किया',
    Dict_live_permission_status_1: 'समीक्षाधीन',
    Dict_live_permission_status_2: 'सक्रिय',
    Dict_live_permission_status_3: 'अस्वीकृत',
    Dict_live_room_status_0: 'शुरू नहीं हुआ',
    Dict_live_room_status_1: 'लाइव',
    Dict_live_room_status_2: 'समाप्त',
    Dict_live_room_status_3: 'असामान्य रुकावट',
    Dict_live_room_type_0: 'प्लेटफ़ॉर्म लाइव',
    Dict_live_room_type_1: 'व्यापारी लाइव',
    Dict_store_type_0: 'व्यक्तिगत स्टोर',
    Dict_store_type_1: 'उद्यम स्टोर',
    Dict_store_sign_status_0: 'हस्ताक्षर लंबित',
    Dict_store_sign_status_1: 'हस्ताक्षरित',
    Dict_store_sign_status_2: 'समाप्त',
    Dict_store_business_change_status_0: 'समीक्षा लंबित',
    Dict_store_business_change_status_1: 'अनुमोदित',
    Dict_store_business_change_status_2: 'अस्वीकृत',
    Dict_decoration_page_type_0: 'होम पेज',
    Dict_decoration_page_type_1: 'श्रेणी पेज',
    Dict_decoration_page_type_2: 'अभियान पेज',
    Dict_decoration_page_type_3: 'कस्टम पेज',
    Dict_decoration_status_0: 'मसौदा',
    Dict_decoration_status_1: 'प्रकाशित',
    Dict_decoration_popup_trigger_page_0: 'प्लेटफ़ॉर्म होम',
    Dict_decoration_popup_trigger_page_1: 'सदस्य केंद्र',
    Dict_decoration_popup_trigger_page_2: 'भुगतान सफल',
    Dict_decoration_popup_target_user_0: 'सभी उपयोगकर्ता',
    Dict_decoration_popup_target_user_1: 'निःशुल्क सदस्य',
    Dict_decoration_popup_target_user_2: 'सशुल्क सदस्य',
    Dict_decoration_popup_frequency_0: 'स्थायी रूप से एक बार',
    Dict_decoration_popup_frequency_1: 'हर बार आने पर',
    Dict_decoration_popup_frequency_2: 'कस्टम आवृत्ति',
    Dict_track_event_type_page_view: 'पेज व्यू',
    Dict_track_event_type_click: 'क्लिक',
    Dict_track_event_type_add_to_cart: 'कार्ट में जोड़ें',
    Dict_track_event_type_search: 'खोज',
    Dict_track_event_type_purchase: 'खरीद',
    Dict_track_event_type_live_watch: 'लाइव देखें',
    Dict_reconcile_period_type_0: 'दैनिक',
    Dict_reconcile_period_type_1: 'साप्ताहिक',
    Dict_reconcile_period_type_2: 'मासिक',
    Dict_store_settlement_status_0: 'निपटान लंबित',
    Dict_store_settlement_status_1: 'निपटाया गया',
    Dict_distributor_status_0: 'समीक्षा लंबित',
    Dict_distributor_status_1: 'समीक्षित',
    Dict_distributor_status_2: 'अस्वीकृत',
    Dict_distribution_commission_type_0: 'प्रत्यक्ष कमीशन',
    Dict_distribution_commission_type_1: 'अप्रत्यक्ष कमीशन',
    Dict_configuration_status_0: 'अक्षम',
    Dict_configuration_status_1: 'सक्षम',
    ...hiLocale
}
export default hi